import React from "react";
import Partner1 from "../../assets/images/partner1.png"
import Partner2 from "../../assets/images/partner2.webp"
import Partner3 from "../../assets/images/partner3.png"

export default function AboutPagePartners() {
  return (
    <div id="partners" className="w-11/12 md:w-8/12 py-8 lg:py-16 text-sky-800 dark:text-sky-500">
      <div className="flex items-center w-full justify-between">
        <h1 className="text-2xl lg:text-3xl md:text-3xl font-semibold ">Our Partners</h1>
       
      </div>
      <div className="grid gap-3 md:gap-5 lg:grid-cols-3 mt-10">
        <Card
          title="DataCamp"
          dp={Partner1}
          des=""
          link="https://www.datacamp.com/"
        />
        <Card
          title="MetaSchool"
          dp={Partner2}
          link="https://metaschool.so/"
        />
        <Card
          title="UIT"
          dp={Partner3}
          link="https://www.uit.edu/"
        />
       
      </div>
    </div>
  );
}

function Card({ title, dp, des, link }) {
  return (
    <a href={link} target="__blank">
    <div className="shadow-md p-5 dark:bg-gray-900 rounded-xl flex hover:shadow-2xl cursor-pointer transition-all">
      <div
        style={{
          backgroundImage: `url(${dp})`,
        }}
        className="bg-cover bg-center h-12 w-12 rounded-full"
      ></div>
      <div className="ml-4 mt-2">
        <h1 className="font-semibold text-lg">{title}</h1>
        {/* <p className="text-xs dark:text-gray-400 text-gray-500"> */}
          {/* Lorem ipsum dolor sit amet consectetur.  */}
        {/* </p> */}
      </div>
    </div>
    </a>
  );
}
